import { render, staticRenderFns } from "./DsArrowUp.vue?vue&type=template&id=7c3551b5&scoped=true"
import script from "./DsArrowUp.vue?vue&type=script&lang=js"
export * from "./DsArrowUp.vue?vue&type=script&lang=js"
import style0 from "./DsArrowUp.vue?vue&type=style&index=0&id=7c3551b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3551b5",
  null
  
)

export default component.exports